// Live figures read from the owner's Google Business listings on 2026-11-04.
export const GOOGLE_LISTINGS = [
  { id: "kota", name: "Garg Stone Company", place: "Kota · IPIA", score: "5.0", count: 45, url: "https://maps.google.com/?cid=4756032706190950519" },
  { id: "ramganj-mandi", name: "Garg Minerals", place: "Ramganj Mandi", score: "5.0", count: 4, url: "https://maps.google.com/?cid=11094439554701431975" },
];

export const PRIMARY_LISTING = GOOGLE_LISTINGS[0];

// Paste real Google reviews here as { author, text, when }. Empty = rating-only section.
export const REVIEWS = [];
